import React from 'react';
import { Box } from '@mui/material';
import { LANGUAGES } from '../../utils/constants';

interface LanguageSwitchProps {
  classes: any;
  isSpanish: boolean;
  onIntentUp: (intentCard: any) => void;
  intentCard: any;
}

const LanguageSwitch: React.FC<LanguageSwitchProps> = ({
  classes,
  isSpanish,
  onIntentUp,
  intentCard,
}) => {
  const renderLanguageOption = (language: string, isActive: boolean) => (
    <div
      className={`${classes.languageOption} ${
        isActive ? classes.languageOptionActive : classes.languageOptionInactive
      }`}
      onMouseUp={() => onIntentUp(intentCard)}
      style={{
        backgroundColor: isActive ? 'rgb(0, 107, 166)' : 'transparent',
        color: isActive ? 'white' : '#4f5153',
      }}
    >
      {language}
    </div>
  );

  return (
    <Box className={classes.languageSwitch} display="flex" gap={2}>
      {renderLanguageOption(LANGUAGES.ENGLISH, !isSpanish)}
      {renderLanguageOption(LANGUAGES.SPANISH, isSpanish)}
    </Box>
  );
};

export default LanguageSwitch;
